import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import { useState } from "react";
import { FieldValues } from "react-hook-form";
import AuthInput, { AuthInputProps } from "./AuthInput";

type AuthPasswordInputProps<T extends FieldValues> = Omit<
  AuthInputProps<T>,
  "inputType" | "endAdornment"
>;

export default function AuthPasswordInput<T extends FieldValues>(
  props: AuthPasswordInputProps<T>
) {
  const [visible, setVisible] = useState(false);

  return (
    <AuthInput
      {...props}
      inputType={visible ? "text" : "password"}
      endAdornment={
        <InputAdornment position="end">
          <IconButton
            aria-label={visible ? "Hide password" : "Show password"}
            aria-pressed={visible}
            aria-controls={`auth-${props.name}`}
            onClick={() => setVisible((v) => !v)}
            onMouseDown={(e) => e.preventDefault()}
            edge="end"
            size="small"
            sx={{ color: "text.secondary", "&:hover": { color: "secondary.main" } }}
          >
            {visible ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
          </IconButton>
        </InputAdornment>
      }
    />
  );
}
